import { render, staticRenderFns } from "./addLaboratory.vue?vue&type=template&id=2a59b108&scoped=true"
import script from "./addLaboratory.vue?vue&type=script&lang=js"
export * from "./addLaboratory.vue?vue&type=script&lang=js"
import style0 from "./addLaboratory.vue?vue&type=style&index=0&id=2a59b108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a59b108",
  null
  
)

export default component.exports